import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { decideIfFullWidthOrFullHeightImg } from "../decideIfFullWidthOrFullHeightImg";
import { changeImageOrientation } from "./changeImageOrientation";
import { useBannerContext } from "oolib";
import { UIContent } from "oolib/dist/UIContent"; // TODO - export update or move file to fe 

export const useReorientImage = ({
  imageRotate,
  setFullWidthOrFullHeightImg,
  setUnderEditImageData,
  publicUrl,
  aspectRatio,
  isFirstMount,
  handleDeleteSingleImage,
  readOnly
}) => {
  const {SET_ALERT_BANNER} = useBannerContext()
  let [imageLazyLoading, setImageLazyLoading] = useState(true);
  const [reorientedImageTempUrl, setReorientedImageTempUrl] =
    useState(undefined);
  
  useEffect(() => {
    if(!imageLazyLoading) setImageLazyLoading(true)
    //if image rotation = undefined / 0 / -0, set reorientedImgTemp -> undefined
    //this way the og public url will be used to render
    if (imageRotate === undefined || [0, -0].indexOf(imageRotate) !== -1) {
      if (reorientedImageTempUrl) setReorientedImageTempUrl(undefined);
      const img = new Image();
      img.src = publicUrl;
      img.onerror = () => {
        /**
         * even tho we have several checks on the okf mediaupload api to  
         * ensure proper file format and such. it is still sometimes possible that
         * an incorrect / corrupt url is being passed through as 'publicUrl' to 
         * this component. In such cases, an error will fire here, and we need to 
         * handle it, by deleting said url and throwing an alert
         */
        if(!readOnly){ //this also fixes another issue. in readonly in some cases (LinkEmbed) on change prop is not available. handleDelete uses the onChange, so this !readOnly condition solves that problem as well
          handleDeleteSingleImage({publicUrl})
          SET_ALERT_BANNER(UIContent.ImageInput.corruptUrlErrMsg, 'red', 3000)
        }else{
          setImageLazyLoading(false) // in read only, let the broken image attempt to render and browser will show some default UI for the error  
        }
      }
      img.onload = function () {
        setFullWidthOrFullHeightImg(
          decideIfFullWidthOrFullHeightImg({
            imgWidth: this.width,
            imgHeight: this.height,
            wrapperAspectRatio: aspectRatio,
          })
        );
        setImageLazyLoading(false)
      };
    } else {
      changeImageOrientation({
        srcUrl: publicUrl,
        imageRotate,
        callback: ({ reorientedUrl, imageWidth, imageHeight }) => {
          //cuz its possible that this may run even if not in edit mode
          //e.g first mount, and on 'dont save changes'

          setFullWidthOrFullHeightImg(
            decideIfFullWidthOrFullHeightImg({
              imgWidth: imageWidth,
              imgHeight: imageHeight,
              wrapperAspectRatio: aspectRatio,
            })
          );
          setReorientedImageTempUrl(reorientedUrl);
          setImageLazyLoading(false)
          // setUrlAfterRotate(resetBase64Image);
        },
      });
    }

    /**
     * if is not first mount, then rotate just happened.
     * so reset crop data
     */
    if (!isFirstMount) {
      //means if it is in edit mode
      setUnderEditImageData((prev) => {
        let newData = cloneDeep(prev);
        delete newData.cropX;
        delete newData.cropY;
        return newData
      });
    }
  }, [imageRotate]);

  return { reorientedImageTempUrl, imageLazyLoading };
};
